import React from 'react'

// The heat steps shared by the Insights calendar (its visualMap) and the
// calendar strip above the timeline (CSS cells), so the two look the same:
// zero, then six steps cut at the quantiles of the non-zero values (the
// mockup's pieces()). colors: chart-theme's heatColors (7 values).
export const heatPieces = (values, colors) => {
  const nz = values.filter(v => v > 0).sort((a, b) => a - b)
  const q = p => nz[Math.floor(p * (nz.length - 1))] || 1
  const cuts = [1, 2, 3, 4, 5].map(i => q(i / 6))
  return [
    { lte: 0, color: colors[0] },
    ...cuts.map((c, i) => ({ gt: i ? cuts[i - 1] : 0, lte: c, color: colors[i + 1] })),
    { gt: cuts[4], color: colors[6] }
  ]
}

// The colour of one value under those pieces.
export const heatColor = (v, pieces) => {
  const hit = pieces.find(p => (p.gt === undefined || v > p.gt) && (p.lte === undefined || v <= p.lte))
  return (hit || pieces[pieces.length - 1]).color
}

// Which ramp a calendar uses: every kind of entry when the timeline
// includes views and launches, else changes only.
export const heatKind = params => (params && params.includeViews === '1' ? 'all' : 'changes')

// The Less ... More key, in the same colours as the cells.
export const HeatScale = ({ colors }) => (
  <span className="au-scale" aria-hidden="true">
    Less {colors.map((c, i) => <i key={i} className="au-sw" style={{ background: c }} />)} More
  </span>
)
